const DEFAULT_TIMEOUT = 3500;
const DEFAULT_CLOSE_TEXT = 'Закрыть';

const state = {
    snackbar: {
        show: false,
        color: '',
        text: '',
        timeout: DEFAULT_TIMEOUT,
        closeText: DEFAULT_CLOSE_TEXT,
        large: false,
    }
};

const getters = {
    snackbar: state => state.snackbar,
}

const actions = {
    showSnackbar({commit}, payload) {
        commit('showSnackbar', payload)
    },
};

const mutations = {
    showSnackbar(state, payload) {
        state.snackbar.color = payload.color
        state.snackbar.text = payload.text
        state.snackbar.timeout = payload.timeout ?? DEFAULT_TIMEOUT
        state.snackbar.closeText = payload.closeText ?? DEFAULT_CLOSE_TEXT
        state.snackbar.large = payload.large ?? false
        state.snackbar.show = true
    },
    hideSnackbar(state) {
        state.snackbar.show = false
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};
